import crud from './helpers/crud';
import List from '../../FastRecruit/models/List';
import _ from 'underscore';
import { servletGet, servletGetResults, servletGetAll, servletSave } from './helpers';

export default class ListDAO extends crud {
  get(params = {}, ...args) {
    if (typeof params !== 'object') {
      return Promise.reject(new Error('Invalid params'));
    }

    return servletGet(this._url, params, ...args).then(lists => _.map(lists, l => new List(l)));
  }

  getSingle(id) {
    if (typeof id !== 'string') {
      return Promise.reject(new Error('Invalid ID'));
    }

    return servletGetResults(join(this._url, id)).then(list => new List(l));
  }

  getAll(...args) {
    return servletGetAll(this._url, ...args).then(lists => _.map(lists, l => new List(l)));
  }

  save(...args) {
    return servletSave(this._url, ...args).then(list => new List(list));
  }
}




// WEBPACK FOOTER //
// ./src/js/util/dao/ListDAO.js